import { useQuery } from "@tanstack/react-query";
import { Loader2, ClipboardList } from "lucide-react";
import api from "@/lib/api";

export default function FormsPanel() {
  const { data, isLoading } = useQuery({ queryKey: ["admin-forms"], queryFn: () => api.get("/admin/forms").then((r) => r.data) });
  return (
    <div data-testid="admin-forms-panel">
      <h2 className="font-serif text-2xl text-[#1A242B] flex items-center gap-2 mb-1"><ClipboardList size={20} className="text-[#144F75]" /> Forms across the platform</h2>
      <p className="text-sm text-[#4A5D6B] mb-5">Every intake form and custom questionnaire built by enhancers and centers.</p>
      {isLoading ? <p className="text-sm text-[#4A5D6B] flex items-center gap-2"><Loader2 className="animate-spin" size={16} /> Loading…</p> : (
        <div className="eyw-card overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-[#F4F1EB] text-[#4A5D6B]">
              <tr><th className="text-left px-4 py-3">Form</th><th className="text-left px-4 py-3">Owner</th><th className="text-left px-4 py-3 hidden md:table-cell">Attached to</th><th className="text-left px-4 py-3">Questions</th><th className="text-left px-4 py-3">Status</th></tr>
            </thead>
            <tbody className="divide-y divide-[#E5E0D8]">
              {(data?.forms || []).map((f) => (
                <tr key={f.id} data-testid={`admin-form-row-${f.id}`}>
                  <td className="px-4 py-3 text-[#1A242B]">{f.title}<span className="block text-[10px] text-[#8FA89B] capitalize">{f.kind === "custom" ? "custom form" : "booking intake"}</span></td>
                  <td className="px-4 py-3 text-[#4A5D6B]">{f.owner_name || "—"}<span className="block text-[10px] text-[#8FA89B] capitalize">{f.owner_type}</span></td>
                  <td className="px-4 py-3 text-[#8FA89B] hidden md:table-cell capitalize">{f.attach_type?.replace("_", " ")}{f.attach_title ? ` · ${f.attach_title}` : ""}</td>
                  <td className="px-4 py-3 text-[#144F75]">{f.question_count}</td>
                  <td className="px-4 py-3">{f.active ? <span className="text-[11px] px-2 py-0.5 rounded-full bg-[#5C8A72]/15 text-[#5C8A72]">active</span> : <span className="text-[11px] px-2 py-0.5 rounded-full bg-[#E5E0D8] text-[#4A5D6B]">inactive</span>}</td>
                </tr>
              ))}
              {(data?.forms || []).length === 0 && <tr><td colSpan={5} className="px-4 py-10 text-center text-[#8FA89B]">No forms created yet.</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
